/**
 * No Dashboard Access Page
 * Shown when a logged-in user's role has no dashboard mapped for it yet
 * (e.g. a newly-added role like PARTNERSHIP_MANAGER). Reached via
 * roleNavigation.js's getDashboardRoute default case.
 */
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const NoDashboardAccess = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-amber-100 mb-4">
            <svg className="h-6 w-6 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 19.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No Dashboard Assigned</h3>
          <p className="text-sm text-gray-600 mb-4">
            You're logged in{user?.role ? <> as <strong>{user.role}</strong></> : null}, but no dashboard has
            been set up for this role yet. Please contact your administrator.
          </p>
          <button
            onClick={() => {
              logout();
              window.location.href = '/login';
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoDashboardAccess;
